module.exports = __webpack_public_path__ + "static/img/interest04.2268ca8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/my-irish-date/interests_images/interest04.png
// module id = hgai
// module chunks = 0